export default __webpack_public_path__ + "static/media/ISFJ.533f5e66.svg";